import React from 'react'
import { Col, Container, Row, } from 'reactstrap';
import LoadingScreen from '../LoadingScreen';

const EmailLayout = ({ title, children, isLoading = false, fixHeight = false }) => {
    return <>
        {isLoading && <LoadingScreen />}
        <Container style={{ marginTop: '2rem' }}>
            <h1>{title || ''}</h1>
            <hr />
            <Row className='justify-content-md-center'>
                <Col style={{
                    height: fixHeight ? '78vh' : 'auto',
                    overflow: fixHeight ? 'scroll' : 'auto'
                }}>
                    {children}
                </Col>
            </Row>
        </Container>
    </>
}

export default EmailLayout;